import {Injectable} from '@angular/core';
import {Mapper} from '../../../../core/abstracts/mapper.abstract';
import {OwnerResponse} from '../models/owner-response.model';
import {Owner} from '../models/owner.model';
import {Page, PageableResponse} from '../../../../core/models/page-response.model';

@Injectable({providedIn: 'root'})
export class VehicleOwnersPageableResponseMapper extends Mapper<PageableResponse<OwnerResponse>, Page<Owner>> {

  map(source: PageableResponse<OwnerResponse>): Page<Owner> {
    const mappedContent = source.content.map(
      response => new Owner(response.id, response.name)
    );

    return Page.fromPaginationResponse<Owner>({
      ...source,
      content: mappedContent
    });
  }
}
